<template>
<!--  v-if="ju()"-->
  <div class="tabbar" :class="{'tabbarsus':$route.name == 'mobileCart'}" v-if="ju()">
    <div v-if="loggedIn" class="tabItem" :class="{active:$route.path == item.path}" v-for="(item,index) in tab" :key="index"
         @click="toUrl(item.path)">
      <div class="tabicon" v-if="showButton(item)" :id="item.name == 'cart' ? 'mobile-cart-icon' : ''">
        <img :src="item.img" alt="">
        <div v-if="item.name == 'cart' && cart > 0" class="cart">{{ cart }}</div>
      </div>
      <span v-if="showButton(item)">{{ $t(item.name) }}</span>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  name: "tabBar",
  data() {
    return {
      tab: [
      {
        name: "previous",
        path: "prev",
        // path: "/collections",
        img: require("../assets/img/arrow_left_wecom.png"),
      },
      {
        name: "home",
        path: "/home",
        img: require("../assets/img/tabbar1.png"),
      }, 
      {
        name: "categories",
        path: "/category",
        // path: "/collections",
        img: require("../assets/img/tabbar2.png"),
      },
      {
        name: "next",
        path: "next",
        // path: "/collections",
        img: require("../assets/img/arrow_right_wecom.png"),
      },
      // {
      //   name: "cart",
      //   path: "/mobileCart",
      //   img: require("../assets/img/tabbar3.png"),
      // },
      // {
      //   name: "favourites",
      //   path: '/favorite',
      //   img: require("../assets/img/fill-favorite.svg"),
      // }, 
      // {
      //   name: "Account",
      //   path: '/account',
      //   img: require("../assets/img/tabbar5.png"),
      // }
      ],
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('products', ['getPrev', 'getNext']),
    toUrl(temp) {
      if (temp === 'prev') {
        this.clickPrev(this.$route.query.productNum);
      }
      else if (temp === 'next') {
        this.clickNext(this.$route.query.productNum);
      } else {
        this.$router.push({path: temp})
      }
    },
    showButton(item){
      if ((item.path === "prev" || item.path === "next") && this.$route.name === "productDetails") {
        return true;
      } else if (item.path !== "prev" && item.path !== "next") {
        return true;
      } else {
        return false;
      }
      // if ()
      // return true;
    },
    ju() {
      // if(this.$route.path == '/mobileSearch' || this.$route.path == '/') {
      //   return false
      // }
      if(this.$route.path == '/mobileSearch') {
        return false
      }
      return true
      // let route = this.$route
      // let flag;
      // this.tab.forEach(item => {
      //   if (route.path == item.path) {
      //     flag = true
      //   }
      // })
      // if (flag) {
      //   return true
      // }
      // return false
    },

    clickPrev(id) {
      this.getPrev(id).then(res => {
        if (res && res.data && res.data[0]) {
          this.$router.push(`/productDetails?productNum=` + res.data[0].ProductNum);
        }
      })
      .catch(err => {
        console.log('error previous', err)
      });
    },
    clickNext(id) {
      this.getNext(id).then(res => {
        if (res && res.data && res.data[0]) {
          this.$router.push(`/productDetails?productNum=` + res.data[0].ProductNum);
        }
      })
      .catch(err => {
        console.log('error next ', err)
      });
    },


  },
  computed: mapState({
    cart: state => state.cart.itemCount,
    loggedIn: state => state.auth.loggedIn,
  })
}
</script>

<style scoped lang="less">

.tabbar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #ffffff;
  box-shadow: 0 -15px 15px 0 rgba(0, 0, 0, 0.03);
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  display: none;
  padding-top: 3px;
  padding-bottom: 10px;

  &.tabbarsus{
    position: absolute;
    top: auto;
    bottom: 65%;
    border-radius: 0 0 20px 20px;
  }

  .tabItem {
    width: 20%;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    color: #d8d8d8;

    &.active {
      color: #E9C34B;

      .tabicon {
        background-color: #E9C34B;
      }
    }

    .tabicon {
      border-radius: 50%;
      background-color: #d8d8d8;
      padding: 6px;
      width: 30px;
      height: 30px;
      position: relative;

      .cart {
        background-color: #fa6400;
        position: absolute;
        right: -2px;
        top: -2px;
        width: 10px;
        height: 10px;
        line-height: 12px;
        font-size: 7px;
        color: #FFFFFF;
        text-align: center;
        border-radius: 10px;
        font-family: Arial;
      }

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    span {
      font-size: 8px;
      margin-top: 5px;
      font-weight: bold;
    }
  }
}

@media only screen and (max-width: 800px) {
  .tabbar {
    display: flex;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabBar.vue